import './App.css';
import Titulo from './componentes/Titulo';
import Contato from './componentes/Contato';
import SobreMim from './componentes/SobreMim';
import Experiencia from './componentes/Experiencia';
import Projetos from './componentes/Projetos';
import Rodape from './componentes/Rodape';
import styled from 'styled-components';

function App() {
  document.title = 'Julio Figueiredo';
  
  return (
    <Wrapper>
      <DottedBackground />
      <Content>
        <Titulo />
        <Contato />
        <div className='sobre'>
          <SobreMim />
        </div>
        <Experiencia />
        <Projetos />
        <Rodape />
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
`;

const DottedBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: white;
  z-index: -1;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: radial-gradient(black 1px, transparent 1px);
    background-size: 10px 10px;
    opacity: 0.1;
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
`;

export default App;
